(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbContentTypeGroupsSearch', [ContentTypeGroupsSearchDirective])
		.controller('ContentTypeGroupsSearchController',
		[
			'$state',
			'gettextCatalog',
			'pxProgressService',
			'smbToolbarService',
			'smbContentTypeGroupsSearchDataStore',
			'smbIconTypes',
			ContentTypeGroupsSearchController
		]);

	var templateUrl = require('./contentTypeGroupsSearch.template');
	function ContentTypeGroupsSearchDirective() {
		return {
			restrict: 'E',
			controller: ContentTypeGroupsSearchController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {}
		};
	}

	function ContentTypeGroupsSearchController($state, gettextCatalog, pxProgressService, smbToolbarService, smbContentTypeGroupsSearchDataStore, smbIconTypes) {
		smbToolbarService.set(gettextCatalog.getString('Search Document Groups'), 'content.home');

		var vm = this;
		vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
		vm.contentTypeGroupsSearchDataStore = smbContentTypeGroupsSearchDataStore;

		pxProgressService.visible = true;
		smbContentTypeGroupsSearchDataStore.loadAllGroups()
			.then(function () {
				pxProgressService.visible = false;
			});
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/contentTypeGroupsSearch/contentTypeGroupsSearch.js
// module id = 74
// module chunks = 1